
import { mapGetters } from 'vuex';

export default {
  name: 'TheMainSubMenu',
  computed: {
    ...mapGetters('menu', [
      'subMenuItems',
      'selectedSubMenuItemId',
      'selectedMainMenuItem'
    ]),
    menuItems() {
      const mainMenuItem = this.selectedMainMenuItem;
      return this.subMenuItems(mainMenuItem.id);
    }
  }
};
